const routes = [
    {
        path: '/contabilidade/alterdata_sistemas/integracoes/:hash',
        alias: ['/contabilidade/alterdata_sistemas/integracoes/index/:hash'],
        component: () => import('../views/Listar'),
    },
    {
        path: '/contabilidade/alterdata_sistemas/integracoes/configurar/:hash',
        component: () => import('../views/Configurar'),
    },
    {
        path: '/contabilidade/alterdata_sistemas/integracoes/visualizar/:hash',
        component: () => import('../views/Visualizar'),
    },
]

export default routes
